import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import AdminGuard from '../components/feature/AdminGuard';

const HomePage = lazy(() => import('../pages/home/page'));
const CursosPage = lazy(() => import('../pages/cursos/page'));
const CarrerasPage = lazy(() => import('../pages/carreras/page'));
const CursoDetallePage = lazy(() => import('../pages/curso-detalle/page'));
const InscripcionPage = lazy(() => import('../pages/inscripcion/page'));
const InscripcionWebPage = lazy(() => import('../pages/inscripcion-web/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const DesarrolloWebPage = lazy(() => import('../pages/soluciones/desarrollo-web/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AlumnosPage = lazy(() => import('../pages/alumnos/page'));

// Payment result pages
const PagoExitosoPage = lazy(() => import('../pages/pago-exitoso/page'));
const PagoPendientePage = lazy(() => import('../pages/pago-pendiente/page'));
const PagoFallidoPage = lazy(() => import('../pages/pago-fallido/page'));

// Article pages
const ArticuloDesarrolladorWeb = lazy(() => import('../pages/articulos/cual-es-el-trabajo-de-un-desarrollador-web/page'));
const Articulo5Habilidades = lazy(() => import('../pages/articulos/5-habilidades-buscadas-en-un-desarrollador-web-en-2025/page'));
const ArticuloIADiseno = lazy(() => import('../pages/articulos/ia-y-diseno-la-revolucion-creativa-del-futuro/page'));
const ArticuloFreelancer = lazy(() => import('../pages/articulos/conviene-ser-freelancer-o-buscar-trabajo-fijo-en-tecnologia/page'));

// Admin pages
const AdminDashboard = lazy(() => import('../pages/admin/page'));
const AdminCursos = lazy(() => import('../pages/admin/cursos/page'));
const CrearCurso = lazy(() => import('../pages/admin/crear-curso/page'));
const AdminCarreras = lazy(() => import('../pages/admin/carreras/page'));
const CrearCarrera = lazy(() => import('../pages/admin/crear-carrera/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminProyectosWeb = lazy(() => import('../pages/admin/proyectos-web/page'));
const EditarProyectoWeb = lazy(() => import('../pages/admin/editar-proyecto-web/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/cursos',
    element: <CursosPage />,
  },
  {
    path: '/carreras',
    element: <CarrerasPage />,
  },
  {
    path: '/curso/:id',
    element: <CursoDetallePage />,
  },
  {
    path: '/inscripcion/:id',
    element: <InscripcionPage />,
  },
  {
    path: '/inscripcion-web',
    element: <InscripcionWebPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '/soluciones/desarrollo-web',
    element: <DesarrolloWebPage />,
  },
  {
    path: '/pago-exitoso',
    element: <PagoExitosoPage />,
  },
  {
    path: '/pago-pendiente',
    element: <PagoPendientePage />,
  },
  {
    path: '/pago-fallido',
    element: <PagoFallidoPage />,
  },
  {
    path: '/articulos/cual-es-el-trabajo-de-un-desarrollador-web',
    element: <ArticuloDesarrolladorWeb />,
  },
  {
    path: '/articulos/5-habilidades-buscadas-en-un-desarrollador-web-en-2025',
    element: <Articulo5Habilidades />,
  },
  {
    path: '/articulos/ia-y-diseno-la-revolucion-creativa-del-futuro',
    element: <ArticuloIADiseno />,
  },
  {
    path: '/articulos/conviene-ser-freelancer-o-buscar-trabajo-fijo-en-tecnologia',
    element: <ArticuloFreelancer />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin',
    element: <AdminGuard><AdminDashboard /></AdminGuard>,
  },
  {
    path: '/admin/cursos',
    element: <AdminGuard><AdminCursos /></AdminGuard>,
  },
  {
    path: '/admin/crear-curso',
    element: <AdminGuard><CrearCurso /></AdminGuard>,
  },
  {
    path: '/admin/editar-curso/:id',
    element: <AdminGuard><CrearCurso /></AdminGuard>,
  },
  {
    path: '/admin/carreras',
    element: <AdminGuard><AdminCarreras /></AdminGuard>,
  },
  {
    path: '/admin/crear-carrera',
    element: <AdminGuard><CrearCarrera /></AdminGuard>,
  },
  {
    path: '/admin/editar-carrera/:id',
    element: <AdminGuard><CrearCarrera /></AdminGuard>,
  },
  {
    path: '/admin/proyectos-web',
    element: <AdminGuard><AdminProyectosWeb /></AdminGuard>,
  },
  {
    path: '/admin/proyectos-web/nuevo',
    element: <AdminGuard><EditarProyectoWeb /></AdminGuard>,
  },
  {
    path: '/admin/proyectos-web/editar/:id',
    element: <AdminGuard><EditarProyectoWeb /></AdminGuard>,
  },
  {
    path: '/alumnos',
    element: <AlumnosPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;